module.exports = __webpack_public_path__ + "img/puzzel1-6.0ebe15bd.png";